// export const ScrollIntoTheView = (id: string) => {
//   let element = document.getElementById(id) as HTMLElement;
//   if (!element) return;

//   element.scrollIntoView({
//     behavior: "smooth",
//     block: "center",
//     inline: "nearest",
//   });
// };


// export function getScrollInfo() {
//   if (typeof window === "undefined") return null;

//   return {
//     scrollY: window.scrollY || window.pageYOffset,
//     scrollHeight: document.body.scrollHeight,
//     clientHeight: window.innerHeight
//   };
// }

export const getScrollInfo = () => {
  if (typeof window === "undefined") return null;

  return {
    scrollY: window.scrollY || window.pageYOffset,
    scrollHeight: document.body.scrollHeight,
    clientHeight: window.innerHeight,
  };
}

export const getOffsetsById = (ids: string[]) => {
  if (typeof window === "undefined") return [];

  return ids.map(id => {
    const el = document.getElementById(id);
    if (!el) return null;
    return { id, offsetTop: el.offsetTop };
  }).filter(Boolean);
}

export const scrollIntoViewById = (id: string) => {
  console.log("scrollIntoViewById 호출됨:", id);

  if (typeof window === "undefined") return;

  const el = document.getElementById(id);
  if (!el) return;

  const scrollAndCheck = (retryCount = 0) => {
    el.scrollIntoView({ behavior: "smooth", block: "start" });

    setTimeout(() => {
      const rect = el.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

      console.log(`✅ ${id} 스크롤 체크 - isVisible:`, isVisible);

      if (isVisible || retryCount >= 3) {
        // 🔥 이동 완료하거나, 2번 이상 시도했으면 Flutter에 알림
        if (window.flutter_inappwebview?.callHandler) {
          window.flutter_inappwebview.callHandler('scrollCompleted', id);
          console.log("🔥 Flutter에게 scroll 완료 전달:", id);
        } else {
          console.log("⚡ Flutter 연결 없음 (브라우저)");
        }
      } else {
        // ❗ 아직 제대로 안 됐으면 한 번 더 재시도
        console.log(`❗ 스크롤 재시도: ${retryCount + 1}`);
        scrollAndCheck(retryCount + 1);
      }
    }, 400); // 애니메이션 시간 고려
  };

  scrollAndCheck();
};
